import {Base} from "@/api/Base"

export class LogList extends Base {
    path = "log/list"
}